import * as React from "react";

/**
 * 홈 대시보드 사이드바 섹션 라벨 (JCG-2110).
 *
 * amber 아이콘 + uppercase muted 제목의 표준 라벨(three-column-layout.md §JCG-2110)을 단일
 * 소유한다. 좌/우 컬럼의 모든 섹션 헤더가 이 컴포넌트를 써 톤·간격을 한 곳에서 관리한다
 * (이전엔 className 문자열을 각 섹션에 복붙 → 표류 위험).
 *
 * 훅·클라이언트 API 가 없는 순수 프레젠테이션 컴포넌트라 서버/클라이언트 양쪽에서 import 가능.
 * lucide 아이콘은 SVG 렌더라 서버 컴포넌트(RecommendedPosts)에서도 안전하다.
 */
export default function SidebarSectionLabel({
  icon: Icon,
  children,
}: {
  icon: React.ElementType;
  children: React.ReactNode;
}) {
  return (
    <h2 className="mb-2 flex items-center gap-1.5 px-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
      <Icon className="h-3.5 w-3.5 text-amber-500" aria-hidden="true" />
      {children}
    </h2>
  );
}
